import { envVariables } from '@kenv';
import { Product } from '@ktypes/enums';
import { StringUtil } from '@kutil';

// defaults to Purposeful if no PRODUCT environment variable set
export const productDisplayName: string = envVariables.PRODUCT
  ? StringUtil.capitalizeFirstLetter(Product[envVariables.PRODUCT.toLowerCase()])
  : StringUtil.capitalizeFirstLetter(Product.purposeful);
